import { useEffect, useState } from 'react';
import { size } from '../../features/Theme/domain/breakpoints';

export function useIsDesktop() {
	const [isDesktop, setIsDesktop] = useState(false);

	useEffect(() => {
		const mql = window.matchMedia(`(min-width: ${size.desktopMin}px)`);

		const onChange = () => {
			setIsDesktop(window.innerWidth >= size.desktopMin);
		};

		mql.addEventListener('change', onChange);

		setIsDesktop(window.innerWidth >= size.desktopMin);

		return () => {
			mql.removeEventListener('change', onChange);
		};
	}, [isDesktop]);

	return isDesktop;
}